module.exports = __webpack_public_path__ + "static/media/naver-over.6011e0f4.svg";